import PubSub from "underpub-js";

var ListingJobsDirectorySection = function (options) {

  this.options = {
    $el: false,
    baseClass: 'el-ListingJobsDirectorySection',
  };

  $.extend(true, this.options, options);

};

ListingJobsDirectorySection.prototype.init = function () {

  var self = this;

  self.$viewAllButton = self.options.$el.find(`.${self.options.baseClass}__view-all__button`);
  self.$chartItems = self.options.$el.find(`.${self.options.baseClass}__chart__item`);

  if (self.$viewAllButton.length && self.$chartItems.length) {
    self.$viewAllButton.on('click', () => {
      self.$chartItems.removeAttr("data-hidden");
      self.$viewAllButton.remove();
    })
  }

};

export default ListingJobsDirectorySection;